import { Component, Input, EventEmitter, Output} from '@angular/core';
import { SneMulChoiceOption } from 'src/app/types/sne';
import { SNE_INPUT_TYPES } from 'src/app/types/sne';
import { HEADER_STATES } from '../../../shared/header/header.helper';
import { SneVideos } from 'src/app/types/sne';

@Component({
  selector: 'ets-sne-single-multi-choice-and-videos',
  templateUrl: './sne-single-multi-choice-and-videos.component.html',
  styleUrls: ['./sne-single-multi-choice-and-videos.component.scss']
})
export class SneSingleMultiChoiceAndVideosComponent {

  constructor() { }

  headerState: HEADER_STATES = HEADER_STATES.BACK;
  @Input() multiChoiceOptions: SneMulChoiceOption[] | undefined;
  @Input() headerQuestion: string | undefined = '';
  @Input() inputType: SNE_INPUT_TYPES | undefined;
  @Input() videos?: SneVideos[];
  @Input() mobileCheck = false;
  @Output() selectSingleResponseEvent = new EventEmitter<string>();
  @Output() selectMultiResponseEvent = new EventEmitter<string>();

  SNE_INPUT_TYPES = SNE_INPUT_TYPES;

  selectSingleResponse(userChoice: string | undefined) {
    if (userChoice) {
      this.selectSingleResponseEvent.emit(userChoice);
    }

  };

  selectMultiResponse(userChoice: string | undefined) {
    if (userChoice) {
      this.selectMultiResponseEvent.emit(userChoice);
    }

  }
}
